export default "__VITE_ASSET__CmqQEg_E__"